import { api } from './client';

export interface DataBrowserFilters {
  limit?: number;
  offset?: number;
  domain?: string;
  status?: string;
  project_id?: string;
  keyword?: string;
  url?: string;
}

function buildQuery(filters: DataBrowserFilters): string {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== '') params.set(k, String(v));
  });
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const dataBrowserApi = {
  list: (filters: DataBrowserFilters = {}) =>
    api.get(`/data-browser${buildQuery(filters)}`),

  serpKeywords: (filters: { limit?: number; offset?: number; project_id?: string; keyword?: string; status?: string; source?: string } = {}) =>
    api.get(`/data-browser/serp-keywords${buildQuery(filters)}`),

  serpResults: (filters: { limit?: number; offset?: number; request_id?: string; project_id?: string; domain?: string; keyword?: string } = {}) =>
    api.get(`/data-browser/serp-results${buildQuery(filters)}`),

  serpResultDetail: (requestId: string) =>
    api.get(`/data-browser/serp-results/${requestId}`),

  serpCoverage: (project_id?: string) => {
    const qs = project_id ? `?project_id=${project_id}` : '';
    return api.get(`/data-browser/serp-coverage${qs}`);
  },

  export: (data: { task_ids?: string[]; format?: string }) =>
    api.post('/data-browser/export', data),

  serpFull: (filters: { project_id?: string; request_id?: string; limit?: number; offset?: number } = {}) =>
    api.get(`/data-browser/serp-full${buildQuery(filters)}`),

  fullContent: (taskId: string) =>
    api.get(`/data-browser/full-content/${taskId}`),
};
